// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"387cca04","302":"8519a5b9","338":"71f62fec","383":"cc1df833","559":"64176219","801":"51bb8282","851":"ed1a8918"}[chunkId] + ".chunk.js";
};